module.exports = __webpack_public_path__ + "static/img/9.08bde86.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/eng/9.png
// module id = /0r0
// module chunks = 0